import { getGuestAttemptId } from '@/utils/guestAttemptId';
const DEFAULT_API_BASE = 'http://127.0.0.1:8787';

const resolveApiBase = () => {
  const envUrl = import.meta.env.VITE_CLOUDFLARE_API_URL;
  if (envUrl && typeof envUrl === 'string' && envUrl.trim()) {
    return envUrl.trim().replace(/\/$/, '');
  }
  return DEFAULT_API_BASE;
};

const parseJsonSafe = async (response) => {
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
};

const request = async (path, init) => {
  const response = await fetch(`${resolveApiBase()}${path}`, init);
  const data = await parseJsonSafe(response);
  if (!response.ok) {
    const message = data?.error || data?.message || `HTTP ${response.status}`;
    throw new Error(message);
  }
  return data;
};

const createIdempotencyKey = (prefix) =>
  `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export class AuthApiClient {
  async requestRegisterCode({ name, email, role }) {
    return request('/auth/register/request-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, email, role }),
    });
  }

  async verifyRegisterCode({ name, email, password, role, code }) {
    const guestId = getGuestAttemptId();
    return request('/auth/register/verify-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        password,
        role,
        code,
        guest_id: guestId || undefined,
      }),
    });
  }

  async verifyRegisterOtp({ name, email, role, code }) {
    const guestId = getGuestAttemptId();
    // Dùng verify-code không gửi password → Worker trả registration_token (tránh 404 khi chưa có route verify-otp).
    return request('/auth/register/verify-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        role,
        code,
        guest_id: guestId || undefined,
      }),
    });
  }

  async completeRegister({ email, password, registration_token }) {
    const guestId = getGuestAttemptId();
    return request('/auth/register/verify-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password,
        registration_token,
        guest_id: guestId || undefined,
      }),
    });
  }

  async register({ name, email, password }) {
    const guestId = getGuestAttemptId();
    return request('/auth/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Idempotency-Key': createIdempotencyKey('register'),
      },
      body: JSON.stringify({ name, email, password, guest_id: guestId || undefined }),
    });
  }

  async login({ email, password }) {
    const guestId = getGuestAttemptId();
    return request('/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Idempotency-Key': createIdempotencyKey('login'),
      },
      body: JSON.stringify({ email, password, guest_id: guestId || undefined }),
    });
  }

  async requestPasswordReset({ email }) {
    return request('/auth/reset-password/request', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
  }
}

